export const images = {
  twentyFourDays:
    'https://images.myloapp.in/NestJsUploads/1668750655855-24days_wOFkC3pT5.webp',
  twentyEightDays:
    'https://images.myloapp.in/NestJsUploads/1668750655861-28days_oe4rxfGls.webp',
  thirtyTwoDays:
    'https://images.myloapp.in/NestJsUploads/1668750655862-32days_nr4Gz9vMFT.webp',
  amaara:
    'https://images.myloapp.in/NestJsUploads/1668750655862-Amaara_2KDk2bb326.webp',
  arpan:
    'https://images.myloapp.in/NestJsUploads/1668752568037-arpan_7lTAscrM1.webp',
  artboard2:
    'https://images.myloapp.in/NestJsUploads/1668752568042-Artboard___2_aQruQg29R.webp',
  artboard4:
    'https://images.myloapp.in/NestJsUploads/1668752568043-Artboard___4_VTJYJhj4c.webp',
  artboard6:
    'https://images.myloapp.in/NestJsUploads/1668752568044-Artboard___6_Ss689lgxo.webp',
  artboard8:
    'https://images.myloapp.in/NestJsUploads/1668752568045-Artboard___8_G-CeEq7ea.webp',
  defaultImageWhite:
    'https://images.myloapp.in/NestJsUploads/1668753299328-default_image_white_vtMCZCeFi.webp',
  dinanath:
    'https://images.myloapp.in/NestJsUploads/1668753299329-dinanath_ZWLysva4D.webp',
  ArrowSlider:
    'https://images.myloapp.in/NestJsUploads/1690362526107-arrow-slider_tooltip.svg',
  divyaBank:
    'https://images.myloapp.in/NestJsUploads/1668753299329-divya_bank_ixbA8DXMh.webp',
  filledStar:
    'https://images.myloapp.in/NestJsUploads/1668753299329-filled.webp',
  chennai:
    'https://images.myloapp.in/NestJsUploads/1668753299331-ich_chennai_ZntzgwTqL.webp',
  installBanner:
    'https://images.myloapp.in/NestJsUploads/1668753763739-installBanner.webp',
  kanchi:
    'https://images.myloapp.in/NestJsUploads/1668753763740-kanchi_xP5pFD1Vo.webp',
  LTMGH_vJqhtleu03:
    'https://images.myloapp.in/NestJsUploads/1668753763742-LTMGH_vJqhtleu03.webp',
  image__11__OnwkurtG1:
    'https://images.myloapp.in/NestJsUploads/1668753763742-MicrosoftTeams-image__11__OnwkurtG1.webp',
  mylocalendar:
    'https://images.myloapp.in/NestJsUploads/1668753763743-mylocalendar_ixWAjDhJ1.webp',
  savedcard:
    'https://images.myloapp.in/NestJsUploads/1668754115499-savedcard.webp',
  sskm_tz01eV6VXm:
    'https://images.myloapp.in/NestJsUploads/1668754115500-sskm_tz01eV6VXm.webp',
  vani_vilas_yqmphPIF2n:
    'https://images.myloapp.in/NestJsUploads/1668754115501-vani_vilas_yqmphPIF2n.webp',
  vijaya_hospital:
    'https://images.myloapp.in/NestJsUploads/1668754115502-vijaya-hospital-759_z9PhLFhu7.webp',
  arrow_gray:
    'https://images.myloapp.in/NestJsUploads/1668754439813-arrow_gray.webp',
  BackArrow:
    'https://images.myloapp.in/NestJsUploads/1668754439814-BackArrow.webp',
  BlackArrow:
    'https://images.myloapp.in/NestJsUploads/1668756668690-blackarrow.svg',
  Clinic:
    'https://images.myloapp.in/NestJsUploads/1668758492441-clinic_Q7YOHEfcn.svg',
  CrossWhite:
    'https://images.myloapp.in/NestJsUploads/1668758492442-cross_white.svg',
  Caution: 'https://images.myloapp.in/NestJsUploads/1677650627119-caution.webp',
  ShareIcon:
    'https://images.myloapp.in/NestJsUploads/1689160654553-share_button.svg',
  CopyIcon: 'https://images.myloapp.in/NestJsUploads/1683820542701-copy.svg',
  LocationBlack:
    'https://images.myloapp.in/NestJsUploads/1677650710069-location_black.svg',
  EditPencil:
    'https://images.myloapp.in/NestJsUploads/1677650710069-edit_pencil.svg',
  MyloPattern:
    'https://images.myloapp.in/NestJsUploads/1677650710069-mylo_pattern_desktop.svg',
  DeliveryCheck:
    'https://images.myloapp.in/NestJsUploads/1677650710070-deliverycheck.webp',
  SuccessNudge:
    'https://images.myloapp.in/NestJsUploads/1677650710070-nudge.gif',
  Down: 'https://images.myloapp.in/NestJsUploads/1668758492443-down.svg',
  lightning:
    'https://images.myloapp.in/NestJsUploads/1688452595214-lightning@3x.webp',
  lightningSectionBg:
    'https://images.myloapp.in/NestJsUploads/1688455553256-Subtraction-5@3x.webp',
  Fb: 'https://images.myloapp.in/NestJsUploads/1668758492443-fb.svg',
  ImageSlider:
    'https://images.myloapp.in/NestJsUploads/1692869253021-circle-slider.webp',
  ImageSliderLactoMama:
    'https://images.myloapp.in/NestJsUploads/1735820967643-Product-slider.webp',
  DaySelectedLactoMama:
    'https://images.myloapp.in/mydo_upload/mydo_upload_1735896245_296328914.png',
  FooterBottomWave:
    'https://images.myloapp.in/NestJsUploads/1668758492443-footerbottomwave.svg',
  FooterTopWave:
    'https://images.myloapp.in/NestJsUploads/1683104259165-topWave.svg',
  Insta: 'https://images.myloapp.in/NestJsUploads/1668758577589-insta.svg',
  LinkedIn:
    'https://images.myloapp.in/NestJsUploads/1668758577589-linkedin.svg',
  results28days:
    'https://images.myloapp.in/NestJsUploads/1690521989785-28-days-visible-results.webp',
  choiceAwards:
    'https://images.myloapp.in/NestJsUploads/1690521989788-Consumer-choice-award.webp',
  Madesafe:
    'https://images.myloapp.in/NestJsUploads/1668758577590-madesafe.svg',
  MyloName:
    'https://images.myloapp.in/NestJsUploads/1668758577590-myloname.svg',
  Parenting:
    'https://images.myloapp.in/NestJsUploads/1668758679352-parenting_QY-ZidvU6.svg',
  PdpHeaderLogo:
    'https://images.myloapp.in/NestJsUploads/1668758679354-pdp_header_logo.svg',
  Store:
    'https://images.myloapp.in/NestJsUploads/1668758679354-store_2QOIzRbRp.svg',
  Toxic: 'https://images.myloapp.in/NestJsUploads/1668758679354-toxic.svg',
  Vegan: 'https://images.myloapp.in/NestJsUploads/1668758679354-vegan.svg',
  Youtube:
    'https://images.myloapp.in/NestJsUploads/1701424950237-yt-footer.svg',
  relatedArticle1:
    'https://images.myloapp.in/NestJsUploads/1668758178991-1b22dfd3-4975-436e-a0f5-9ceed3c07326.webp',
  relatedArticle2:
    'https://images.myloapp.in/NestJsUploads/1668758178992-05fbd640-b06a-4423-b248-09841a4d4c16.webp',
  relatedArticle3:
    'https://images.myloapp.in/NestJsUploads/1668758178992-35bfb3a2-9d20-46ee-bb66-52156d9869d6.webp',
  relatedArticle4:
    'https://images.myloapp.in/NestJsUploads/1668758178993-484BE238-A30E-D21B-A000-4D5C9D0FAFF0.webp',
  relatedArticle5:
    'https://images.myloapp.in/NestJsUploads/1668758178993-514c0923-c322-4d1f-8afe-c04590de7be0.webp',
  relatedArticle6:
    'https://images.myloapp.in/NestJsUploads/1668758560560-781c46e0-7403-402f-baab-678951c6427c.webp',
  relatedArticle7:
    'https://images.myloapp.in/NestJsUploads/1668758560561-6055CE06-69EA-4020-A323-EFFDA07007B0.webp',
  relatedArticle8:
    'https://images.myloapp.in/NestJsUploads/1668758560561-7946DAA8-1CE0-F435-E9AC-26904C6D6050.webp',
  relatedArticle9:
    'https://images.myloapp.in/NestJsUploads/1668758560562-9044c6a3-9e91-40c8-b1a1-5823defc60a5.webp',
  relatedArticle10:
    'https://images.myloapp.in/NestJsUploads/1668758560563-25653a14-45e1-48b5-8a27-cb0cb4d8a97f.webp',
  relatedArticle11:
    'https://images.myloapp.in/NestJsUploads/1668758815275-22645958-1bd6-4ee1-b20b-ab2ffaaa52f8.webp',
  relatedArticle12:
    'https://images.myloapp.in/NestJsUploads/1668758815276-B6F4E4E2-BDBA-E90C-A2D9-07D3F2C37532.webp',
  relatedArticle13:
    'https://images.myloapp.in/NestJsUploads/1668758815277-CE18B3E0-270D-90DC-10CA-FAEA8FF9299E.webp',
  expert_consultation:
    'https://images.myloapp.in/NestJsUploads/1668759083102-SMC_expert_consultation_HW4SBtWl5.webp',
  combinee:
    'https://images.myloapp.in/NestJsUploads/1668759157638-combinee.webp',
  clinic:
    'https://images.myloapp.in/NestJsUploads/1668759357485-clinic_Q7YOHEfcn.svg',
  parent: 'https://images.myloapp.in/NestJsUploads/1668759357486-parent.svg',
  parenting_QY:
    'https://images.myloapp.in/NestJsUploads/1668759357487-parenting_QY-ZidvU6.svg',
  pregnancy:
    'https://images.myloapp.in/NestJsUploads/1668759357487-pregnancy.svg',
  store_2QOIzRbRp:
    'https://images.myloapp.in/NestJsUploads/1668759357487-store_2QOIzRbRp.svg',
  ttc: 'https://images.myloapp.in/NestJsUploads/1668759542671-ttc.svg',
  downloadApp:
    'https://images.myloapp.in/NestJsUploads/1668759888797-downloadapp.webp',
  carousel_left_arrow:
    'https://images.myloapp.in/NestJsUploads/1689658849638-left.svg',
  carousel_right_arrow:
    'https://images.myloapp.in/NestJsUploads/1689658849636-right.svg',
  order_successful:
    'https://images.myloapp.in/NestJsUploads/1668754439815-order_successful.webp',
  treatmentbanner:
    'https://images.myloapp.in/NestJsUploads/1668760073898-treatmentbanner_lxNlshkdr.webp',
  community:
    'https://images.myloapp.in/NestJsUploads/1668760302299-community.webp',
  dailytip:
    'https://images.myloapp.in/NestJsUploads/1668760302300-dailytip.webp',
  qnaimg: 'https://images.myloapp.in/NestJsUploads/1668760302301-qnaimg.webp',
  toolguides:
    'https://images.myloapp.in/NestJsUploads/1668760302303-toolguides.webp',
  degree: 'https://images.myloapp.in/NestJsUploads/1668766400415-degree.svg',
  mylo_mobile_images:
    'https://images.myloapp.in/NestJsUploads/1668766553191-mylo_mobile_images_bJYnBB2iy.webp',
  comment: 'https://images.myloapp.in/NestJsUploads/1668766887301-comment.webp',
  consultantDoctor:
    'https://images.myloapp.in/NestJsUploads/1668766887304-consultantDoctor_K6xMlY5GqJ.webp',
  consultDoctor:
    'https://images.myloapp.in/NestJsUploads/1669031515314-consultantdoctornew_5a7j5ij37.webp',
  pinkrightarrow:
    'https://images.myloapp.in/NestJsUploads/1668766887308-pinkrightarrow.webp',
  whiteadded:
    'https://images.myloapp.in/NestJsUploads/1668766887308-whiteadded.webp',
  filledstarSvg:
    'https://images.myloapp.in/NestJsUploads/1668768064773-filledstar.svg',
  breastfeading:
    'https://images.myloapp.in/NestJsUploads/1668768195763-breastfeading.svg',
  pregwomen:
    'https://images.myloapp.in/NestJsUploads/1668768195764-pregwomen.svg',
  trimseter:
    'https://images.myloapp.in/NestJsUploads/1668768195765-trimseter.svg',
  yellowWave:
    'https://images.myloapp.in/NestJsUploads/1668768366290-YellowWave.svg',
  emptystar:
    'https://images.myloapp.in/NestJsUploads/1668769049416-emptystar.svg',
  arrowdownforward:
    'https://images.myloapp.in/NestJsUploads/1668590714677-arrowdownforward_yPJNcHBTA_1.webp',
  installappoti: 'https://images.myloapp.in/angularAssets/installappoti.svg',
  logo: 'https://images.myloapp.in/NestJsUploads/1692007770815-Logo-96.webp',
  popupLogo:
    'https://images.myloapp.in/NestJsUploads/1700217979685-Mask-Group-1.svg',
  arrow_verm: 'https://images.myloapp.in/angularAssets/arrow_verm.svg',
  new_star_half_empty:
    'https://images.myloapp.in/NestJsUploads/1668591049135-new_star_half_empty_W7Iupona3.webp',
  happinesspatternsingle:
    'https://images.myloapp.in/NestJsUploads/1668591049133-happinesspatternsingle_uECMRxK5T.webp',
  default_image:
    'https://images.myloapp.in/NestJsUploads/1675313593156-mylo_happiness_logo.svg',
  confettiGif:
    'https://images.myloapp.in/NestJsUploads/1668591318392-mydo_upload_1646199156_1146819233.gif',
  defaultImage:
    'https://images.myloapp.in/NestJsUploads/1668581912764-defaultimage.webp',
  arrowDownForward:
    'https://images.myloapp.in/NestJsUploads/1668590714677-arrowdownforward_yPJNcHBTA_1.webp',
  arrowForwardWhite:
    'https://images.myloapp.in/NestJsUploads/1707220725359-right-arrow_white.svg',
  babyNameFinder:
    'https://images.myloapp.in/webP_images/8c2eb6f5-3c6a-49f9-85f5-ad305faad4b9.webp',
  babyGirlGender:
    'https://images.myloapp.in/NestJsUploads/1668590624177-babygirlgender.webp',
  babyBoyGender:
    'https://images.myloapp.in/NestJsUploads/1668590714678-babyboygender_1.webp',
  whatsappImage: 'https://images.myloapp.in/angularAssets/whatsappimage.svg',
  aboutImage: 'https://images.myloapp.in/angularAssets/about.svg',
  refreshIcon: 'https://images.myloapp.in/angularAssets/refreshred.svg',
  toolBannerWave: 'https://images.myloapp.in/angularAssets/wave.png',
  downloadAppCommunity:
    'https://images.myloapp.in/NestJsUploads/1668772069469-downloadappcommunity_mP_btXMFG.webp',
  arrowRedForward:
    'https://images.myloapp.in/NestJsUploads/1691734914724-arrow_forward_ios_black_24dp.svg',
  nauseaandvomit:
    'https://images.myloapp.in/tags/tags1550580658_1785742166.webp',
  preganddiet: 'https://images.myloapp.in/tags/tags1550478378_593040290.webp',
  laboranddelivery:
    'https://images.myloapp.in/tags/tags1550477939_932962573.webp',
  tiredness: 'https://images.myloapp.in/tags/tags1550580658_1785742166.webp',
  myloLogoUnit:
    'https://images.myloapp.in/angularAssets/tr:di-default-image.jpg:q-100/mylo-logo-unit.png',
  elevenSign: 'https://images.myloapp.in/tags/tags1566461509_1376511117.webp',
  safelyWithPartner:
    'https://images.myloapp.in/tags/tags1573117508_1685259888.webp',
  testimonialVtwoOne:
    'https://images.myloapp.in/angularAssets/testimonial_v2_1.png',
  testimonialVOneOne:
    'https://images.myloapp.in/angularAssets/testimonial_v1_1.png',
  testimonialVTwoTwo:
    'https://images.myloapp.in/angularAssets/testimonial_v2_2.png',
  testimonialVOneTwo:
    'https://images.myloapp.in/angularAssets/testimonial_v1_2.png',
  testimonialVTwoThree:
    'https://images.myloapp.in/angularAssets/testimonial_v2_3.png',
  testimonialVOneThree:
    'https://images.myloapp.in/angularAssets/testimonial_v1_3.png',
  googlePlay:
    'https://images.myloapp.in/NestJsUploads/1668598861483-GooglePlay.webp',
  appstore:
    'https://images.myloapp.in/NestJsUploads/1668598861484-appstore.webp',
  myloHeaderLogo:
    'https://images.myloapp.in/NestJsUploads/1670829302039-mylowithoutraise.svg',
  rightArrow: 'https://images.myloapp.in/angularAssets/right_arrow.svg',
  articleCert: 'https://images.myloapp.in/angularAssets/article.svg',
  dailyTip: 'https://images.myloapp.in/angularAssets/dailytip.svg',
  communityCert: 'https://images.myloapp.in/angularAssets/community.svg',
  companionPhone: 'https://images.myloapp.in/angularAssets/companionphone.png',
  certWave: 'https://images.myloapp.in/angularAssets/wave.png',
  contact_popup:
    'https://images.myloapp.in/angularAssets/tr:di-default-image.jpg:q-100/contact_popup.png?ik-sdk-version=react-1.0.9',
  telephoneIcon:
    'https://images.myloapp.in/angularAssets/tr:di-default-image.jpg:w-40,q-100/telephone.webp?ik-sdk-version=react-1.0.9',
  footerBanner: 'https://images.myloapp.in/angularAssets/footerBanner.svg',
  checkGreen:
    'https://images.myloapp.in/NestJsUploads/1684920319696-check-mark@3x.webp',
  twoPhone: 'https://images.myloapp.in/angularAssets/twophone.png',
  myloSmallIcon:
    'https://images.myloapp.in/NestJsUploads/1668598861483-mylosmallicon.webp',
  googlePlayIcon:
    'https://images.myloapp.in/NestJsUploads/1668598861483-GooglePlay.webp',
  desktopClothDiaper:
    'https://images.myloapp.in/NestJsUploads/1668773156727-desktopClothDiaper_zmEATgLPU.webp',
  mobileClothDiaper:
    'https://images.myloapp.in/NestJsUploads/1668773156729-mobileClothDiaper_UKfrbISynr.webp',
  diaperImage:
    'https://images.myloapp.in/gullack_products/product_1662024682_795297264.webp',
  plusSvg: 'https://images.myloapp.in/angularAssets/plus.svg',
  plusBlack:
    'https://images.myloapp.in/NestJsUploads/1675320705191-plusblack.svg',
  sidedrawerwave: 'https://images.myloapp.in/angularAssets/sidedrawerwave.svg',
  arrow_grey: 'https://images.myloapp.in/angularAssets/arrow_grey.png',
  appStoreIcon:
    'https://images.myloapp.in/NestJsUploads/1668598861484-appstore.webp',
  qrCode: 'https://images.myloapp.in/NestJsUploads/1668591318393-qrcode.webp',
  helpSection:
    'https://images.myloapp.in/NestJsUploads/1678693272375-help_black_24dp@3x.webp',
  myloMobile:
    'https://images.myloapp.in/NestJsUploads/1668591318393-mylomobile.webp',
  paymentGroup:
    'https://images.myloapp.in/NestJsUploads/1668598861482-paymentgroup.webp',
  secure: 'https://images.myloapp.in/NestJsUploads/1668599299643-secure.webp',
  phone_call:
    'https://images.myloapp.in/NestJsUploads/1668599299641-phone-call.webp',
  footer_email:
    'https://images.myloapp.in/NestJsUploads/1668599299640-email.webp',
  ani_news:
    'https://images.myloapp.in/NestJsUploads/1675664358445-Ani_gOowAIbbD.webp',
  businessToday:
    'https://images.myloapp.in/NestJsUploads/1675664358449-business_today_cwEEYqWQK.webp',
  businessWorld:
    'https://images.myloapp.in/NestJsUploads/1675664358450-businessworld_UxpZSnG_7.webp',
  economic_times:
    'https://images.myloapp.in/NestJsUploads/1675664358451-Economic_times_OSn3aXuTn.webp',
  times_of_india:
    'https://images.myloapp.in/NestJsUploads/1675664520353-toi_WfqL0pNh1.webp',
  financialExpress:
    'https://images.myloapp.in/NestJsUploads/1675664358451-financial_express__Y57s0-pmy.webp',
  yourStory:
    'https://images.myloapp.in/NestJsUploads/1675664520356-your_story_G0h40hhV1.webp',
  upImage: 'https://images.myloapp.in/angularAssets/up.svg',
  grey_arrow: 'https://images.myloapp.in/angularAssets/arrow_grey.png',
  sideDrawer: 'https://images.myloapp.in/angularAssets/sidedrawerwave.svg',
  starIcon: 'https://images.myloapp.in/angularAssets/star.svg',
  crueltyCert: 'https://images.myloapp.in/angularAssets/cruelty.svg',
  shopBanner: 'https://images.myloapp.in/angularAssets/shopbanner.png',
  shopBannerWave: 'https://images.myloapp.in/angularAssets/wave.svg',
  greenTick: 'https://images.myloapp.in/angularAssets/greentick.svg',
  iuiImageOne:
    'https://images.myloapp.in/NestJsUploads/1668772069473-iuiivf2_CmL4QUaXD.webp',
  iuiImageThree:
    'https://images.myloapp.in/NestJsUploads/1668772069474-iuiivf3_xA6hE-JXD.webp',
  iuiImageFour:
    'https://images.myloapp.in/NestJsUploads/1668772069474-iuiivf4_Jqlt2GiDC.webp',
  iuiImageFive:
    'https://images.myloapp.in/NestJsUploads/1668772214072-iuiivf5_cXUqHiR3n.webp',
  iuiImageSix:
    'https://images.myloapp.in/NestJsUploads/1668772214073-iuiivf6_BXmZ1krU7.webp',
  iuiImageSeven:
    'https://images.myloapp.in/NestJsUploads/1668772214073-iuiivf7_LjDVxY3Hu.webp',
  greendiscount: 'https://images.myloapp.in/angularAssets/greendiscount.svg',
  paymentgroup:
    'https://images.myloapp.in/NestJsUploads/1668598861482-paymentgroup.webp',
  qrcode: 'https://images.myloapp.in/NestJsUploads/1668591318393-qrcode.webp',
  essentials: 'https://images.myloapp.in/angularAssets/essentials.png',
  care: 'https://images.myloapp.in/angularAssets/Care.png',
  keyboard_arrow_down:
    'https://images.myloapp.in/angularAssets/keyboard_arrow_down.png',
  checked: 'https://images.myloapp.in/angularAssets/checked.png',
  duedate:
    'https://images.myloapp.in/mydo_upload/mydo_upload_1594374607_263353011.png',
  contraction:
    'https://images.myloapp.in/mydo_upload/mydo_upload_1594374674_557705479.png',
  babyexpendeture:
    'https://images.myloapp.in/mydo_upload/mydo_upload_1594374856_1836936013.png',
  babynames:
    'https://images.myloapp.in/mydo_upload/mydo_upload_1633603043_1002022904.png',
  premature_delivery:
    'http://images.myloapp.in/tags/tags1566461509_1376511117.webp',
  topicImage2: 'http://images.myloapp.in/tags/tags1573117508_1685259888.webp',
  topicImage3:
    'http://images.myloapp.in/tags/tags9b844573-3755-4782-9d88-e4b32c9ac5dc.webp',
  milkbankDweb:
    'https://images.myloapp.in/NestJsUploads/1668773266622-MicrosoftTeams-image__4__5RA9_rUVR.webp',
  milkbankMweb:
    'https://images.myloapp.in/NestJsUploads/1668773266621-MicrosoftTeams-image__3__KTuhkxnMg.webp',
  reasonHappy: 'https://images.myloapp.in/angularAssets/happy.png',
  reasonInfertility: 'https://images.myloapp.in/angularAssets/infertility.png',
  reasonConception:
    'https://images.myloapp.in/angularAssets/pregnancy-test.png',
  reasonBabyHead: 'https://images.myloapp.in/angularAssets/baby-head.png',
  reasonCalendar: 'https://images.myloapp.in/angularAssets/calendar.png',
  cloudNine: 'https://images.myloapp.in/angularAssets/cloud9.png',
  apolloHospital: 'https://images.myloapp.in/angularAssets/apollohospital.png',
  motherHood: 'https://images.myloapp.in/angularAssets/motherhood.png',
  arrowWhite: 'https://images.myloapp.in/angularAssets/arrowhite.svg',
  phoneBlack: 'https://images.myloapp.in/angularAssets/phoneblack.svg',
  callWhite: 'https://images.myloapp.in/angularAssets/callwhite.svg',
  rightTick: 'https://images.myloapp.in/angularAssets/righttick.svg',
  ahana: 'https://images.myloapp.in/angularAssets/ahana.png',
  prisha: 'https://images.myloapp.in/angularAssets/prisha.png',
  halfRect: 'https://images.myloapp.in/angularAssets/halfrect.svg',
  ivfWork:
    'https://images.myloapp.in/mydo_upload/mydo_upload_1561701901_892272458.webp',
  ivfTreatment:
    'https://images.myloapp.in/webP_images/d780c2a4-fa65-4039-89aa-ad3567c5f27e.webp',
  miracleBaby:
    'https://images.myloapp.in/mydo_upload/mydo_upload_1561635610_1153863724.webp',
  vitro:
    'https://images.myloapp.in/webP_images/13f094cb-5853-4224-8f94-7e8c03ab9d45.webp',
  ayurvedic:
    'https://images.myloapp.in/mydo_upload/mydo_upload_1561635858_732226354.webp',
  fertilization:
    'https://images.myloapp.in/mydo_upload/mydo_upload_1577454177_1911718027.webp',
  newborn: 'https://images.myloapp.in/tags/tags1550478001_654976880.webp',
  early_pregnancy:
    'https://images.myloapp.in/tags/tags4e22ccf1-22e2-4265-9ad4-68f2e202a1ee.webp',
  newMom:
    'https://images.myloapp.in/mydo_upload/mydo_upload_1561634635_1959560801.webp',
  diet_nutrition:
    'https://images.myloapp.in/mydo_upload/mydo_upload_1577456127_758367502.webp',
  pregnancy_journey:
    'https://images.myloapp.in/mydo_upload/mydo_upload_1558350301_1410321134.webp',
  food_recipes:
    'https://images.myloapp.in/mydo_upload/mydo_upload_1577456273_239777864.webp',
  is_it_normal: 'http://images.myloapp.in/tags/tags1550580658_1785742166.webp',
  food_cravings: 'http://images.myloapp.in/tags/tags1550478378_593040290.webp',
  labour_birth: 'http://images.myloapp.in/tags/tags1550477939_932962573.webp',
  white_arrow: 'https://images.myloapp.in/angularAssets/white_arrow.svg',
  arrowforward:
    'https://images.myloapp.in/NestJsUploads/1668773844547-arrowforward_sWR7ZFijx.svg',
  Artboard___3:
    'https://images.myloapp.in/NestJsUploads/1668773557174-Artboard___3_vJJ8kOPc2.webp',
  Artboard___7:
    'https://images.myloapp.in/NestJsUploads/1668773557176-Artboard___7_HFFIW7HWm.webp',
  Artboard___1:
    'https://images.myloapp.in/NestJsUploads/1668773557173-Artboard___1_j6tac6UH8.webp',
  Artboard___5:
    'https://images.myloapp.in/NestJsUploads/1668773557175-Artboard___5_fuDdRk0aB.webp',
  Artboard___6:
    'https://images.myloapp.in/NestJsUploads/1668773557175-Artboard___6_Ss689lgxo.webp',
  hi_bangla_dweb1:
    'https://images.myloapp.in/NestJsUploads/1668772971775-hi_bangla_dweb_19gO1TXwc.webp',
  hi_bangla_mweb1:
    'https://images.myloapp.in/NestJsUploads/1668772971776-hi_bangla_mweb_rNaG8i8dy.webp',
  hi_bangla_dweb2:
    'https://images.myloapp.in/NestJsUploads/1668772971775-hi_bangla_dweb_19gO1TXwc.webp',
  hi_bangla_mweb2:
    'https://images.myloapp.in/NestJsUploads/1668772971776-hi_bangla_mweb_rNaG8i8dy.webp',
  desktopImage_164454941925:
    'https://images.myloapp.in//general-item/771/webp/desktopImage_164454941925.webp',
  desktopImage_164454939968:
    'https://images.myloapp.in//general-item/772/webp/desktopImage_164454939968.webp',
  desktopImage_164454938433:
    'https://images.myloapp.in//general-item/773/webp/desktopImage_164454938433.webp',
  days35:
    'https://images.myloapp.in/NestJsUploads/1668773844540-35days_x90J_m7sK.webp',
  pregnancy_147934:
    'https://images.myloapp.in/webP_images/23134ba9-a6a0-4df6-b456-0816a2cf48c4.webp',
  period_37177:
    'https://images.myloapp.in/webP_images/c74ca7d5-f92c-4f9a-b01a-842affdd886d.webp',
  home_24588:
    'https://images.myloapp.in/webP_images/b1360ec0-a59d-4b25-9605-8fa19b787a53.webp',
  period_1546:
    'https://images.myloapp.in/webP_images/53fc4a9b-5171-455b-91e7-f1734f3c90ad.webp',
  conception_34976:
    'https://images.myloapp.in/webP_images/ae27be18-34a4-4853-ab04-329927df3ab9.webp',
  periods_155206:
    'https://images.myloapp.in/webP_images/a21011b0-94ff-477c-9f8e-bed7d0f53742.webp',
  whitePeoplebg: 'https://images.myloapp.in/angularAssets/whatpeoplebg.png',
  plusGroup: 'https://images.myloapp.in/angularAssets/plusgroup.svg',
  padLock: 'https://images.myloapp.in/angularAssets/padlock.svg',
  whyMyloDesktop: 'https://images.myloapp.in/angularAssets/whymylodesk.svg',
  whyMyloMobile: 'https://images.myloapp.in/angularAssets/whymylomobile.svg',
  greenWallet: 'https://images.myloapp.in/angularAssets/greenwallet.svg',
  greenOne: 'https://images.myloapp.in/angularAssets/greenone.svg',
  userGreen: 'https://images.myloapp.in/angularAssets/usergreen.svg',
  joinCommunity: 'https://images.myloapp.in/angularAssets/joincommunity.png',
  crueltyDetail:
    'https://images.myloapp.in/NestJsUploads/1668590624181-cruelty.webp',
  shieldNew: 'https://images.myloapp.in/angularAssets/shield_new.png',
  humanchain: 'https://images.myloapp.in/angularAssets/humanchain.svg',
  Bhargavi:
    'https://images.myloapp.in/NestJsUploads/1668773934783-Dr.-Bhargavi-Reddy-280.webp',
  locked: 'https://images.myloapp.in/NestJsUploads/1669293974381-locked.webp',
  Gift: 'https://images.myloapp.in/NestJsUploads/1669294323051-gift.webp',
  non_refund:
    'https://images.myloapp.in/NestJsUploads/1670571949862-non_refund.svg',
  white_arrow_Up:
    'https://images.myloapp.in/NestJsUploads/1672657587617-white_arrow_up.webp',
  newFilledStar:
    'https://images.myloapp.in/NestJsUploads/1672657840613-new_filled_star.webp',
  yellowFilledStar:
    'https://images.myloapp.in/NestJsUploads/1693555897977-Polygon-1@3x.webp',
  newEmptyStar:
    'https://images.myloapp.in/NestJsUploads/1672658225275-new_star_empty.webp',
  thumbsUp:
    'https://images.myloapp.in/NestJsUploads/1672658377319-thumb_up.webp',
  minusSvg:
    'https://images.myloapp.in/NestJsUploads/1675167884897-minusblack.svg',
  razorPayTrustedBadge:
    'https://images.myloapp.in/NestJsUploads/1676366223980-Group-129614.svg',
  thumbsUpRedNew:
    'https://images.myloapp.in/NestJsUploads/1693812285102-selected-upward-thumb.svg',
  thumbsUpNew:
    'https://images.myloapp.in/NestJsUploads/1693812285104-unselected-upward-thumb.svg',
  thumbsDownNew:
    'https://images.myloapp.in/NestJsUploads/1693812285105-unselected-downward-thumb.svg',
  thumbsDownRedNew:
    'https://images.myloapp.in/NestJsUploads/1693812285105-selected-downward-thumb.svg',
  backArrowCart:
    'https://images.myloapp.in/NestJsUploads/1672659685716-backarrowcart.webp',
  backArrowCartBlack:
    'https://images.myloapp.in/NestJsUploads/1676366223978-Group-129609.svg',
  myloCoin: 'https://images.myloapp.in/NestJsUploads/1674456653075-mcoin.webp',
  fastDelivery:
    'https://images.myloapp.in/NestJsUploads/1673863480781-fastdelivery.svg',
  poweredByRazorpay:
    'https://images.myloapp.in/NestJsUploads/1673863480783-poweredbyrazorpay.svg',
  poweredByJuspay:
    'https://images.myloapp.in/NestJsUploads/1693829169790-MicrosoftTeams-image-(1).webp',
  airtel: 'https://images.myloapp.in/NestJsUploads/1673863637057-airtel.webp',
  cashonDelivery:
    'https://images.myloapp.in/NestJsUploads/1673863637061-cashondelivery.webp',
  creditCard:
    'https://images.myloapp.in/NestJsUploads/1673863637062-creditcard.webp',
  freeCharge:
    'https://images.myloapp.in/NestJsUploads/1673863721832-freecharge.webp',
  googlePlay:
    'https://images.myloapp.in/NestJsUploads/1673863721835-googlepay.webp',
  mobikwik:
    'https://images.myloapp.in/NestJsUploads/1673863721836-mobikwik.webp',
  online: 'https://images.myloapp.in/NestJsUploads/1673863721836-online.webp',
  paytm: 'https://images.myloapp.in/NestJsUploads/1673863907289-paytm11.webp',
  phonepay:
    'https://images.myloapp.in/NestJsUploads/1673863907294-phonepay.webp',
  map: 'https://images.myloapp.in/NestJsUploads/1673938297836-gps.webp',
  fastRefund:
    'https://images.myloapp.in/NestJsUploads/1673957178964-fastrefunds.webp',
  parcel:
    'https://images.myloapp.in/NestJsUploads/1673957178969-parcel@3x.webp',
  safeBottom:
    'https://images.myloapp.in/NestJsUploads/1673957178969-safe_bottom.webp',
  codPopupImg:
    'https://images.myloapp.in/NestJsUploads/1674024658281-codmobile.svg',
  rtcDesktop:
    'https://images.myloapp.in/NestJsUploads/1675145934742-desktop-selection-slide.gif',
  rtcMobile:
    'https://images.myloapp.in/NestJsUploads/1675146101113-mobile-selection-slide.gif',
  diapernewDwebTopBanner:
    'https://images.myloapp.in/NestJsUploads/1676609943380-cdnewversiontopdesktopbanner.webp',
  diapernewmwebtopBanner:
    'https://images.myloapp.in/NestJsUploads/1676608652164-cdnewversiontopbanner.webp',
  mobilegoodnesscloth:
    'https://images.myloapp.in/NestJsUploads/1675162707718-mobilegoodnesscloth.webp',
  mobileHappiness:
    'https://images.myloapp.in/NestJsUploads/1675162707720-mobilehappiness.webp',
  mobileInnerfabric:
    'https://images.myloapp.in/NestJsUploads/1675162707721-mobileinnerfabric.webp',
  mobileNoLeakage:
    'https://images.myloapp.in/NestJsUploads/1675162707721-mobilenoleakage.webp',
  mobileNomorerashes:
    'https://images.myloapp.in/NestJsUploads/1675162707721-mobilenomorerashes.webp',
  mobileOkeotex:
    'https://images.myloapp.in/NestJsUploads/1675163150252-mobileoekotax.webp',
  desktopGoodnesscloth:
    'https://images.myloapp.in/NestJsUploads/1675163181614-desktopGoodnesscloth.webp',
  desktopHappiness:
    'https://images.myloapp.in/NestJsUploads/1675163181615-desktophappiness.webp',
  desktopInnerFabric:
    'https://images.myloapp.in/NestJsUploads/1675163181616-desktopinnerfabric.webp',
  desktopNoLeakage:
    'https://images.myloapp.in/NestJsUploads/1675163181617-desktopnoleakage.webp',
  desktopNoMorerashes:
    'https://images.myloapp.in/NestJsUploads/1675163181617-desktopnomorerashes.webp',
  desktopOkeoTax:
    'https://images.myloapp.in/NestJsUploads/1675163369173-desktopOekoTex.webp',
  desktopGrowalong:
    'https://images.myloapp.in/NestJsUploads/1675169444056-growsalongwithbaby.webp',
  mobileGrowsalong:
    'https://images.myloapp.in/NestJsUploads/1675169513113-mobilegrowsalong.webp',
  defaultCategory:
    'https://images.myloapp.in/NestJsUploads/1675161011546-Group-121955.svg',
  trustOeko:
    'https://images.myloapp.in/NestJsUploads/1687845336942-Oeko-Tex-Certified.webp',
  trustGoodness:
    'https://images.myloapp.in/NestJsUploads/1687845336945-Goodness-of-Cloth.webp',
  trustLeakProof:
    'https://images.myloapp.in/NestJsUploads/1687845336946-5-hour-leak-proof.webp',
  trustDoctorRecommend:
    'https://images.myloapp.in/NestJsUploads/1687845336945-Doctor-Recommended.webp',
  share:
    'https://images.myloapp.in/NestJsUploads/1679400191100-share_black_24dp-(2).svg',
  views_icon:
    'https://images.myloapp.in/NestJsUploads/1679485356817-views_icon.svg',
  answers: 'https://images.myloapp.in/NestJsUploads/1679484965160-views.svg',
  whatsapp:
    'https://images.myloapp.in/NestJsUploads/1680676636383-NoPath---Copy-(21)@2x.webp',
  newtrackordericon:
    'https://images.myloapp.in/NestJsUploads/1680769104943-newtrackordericon.svg',
  newwhatsappicon:
    'https://images.myloapp.in/NestJsUploads/1680769104941-newwhatsappicon.svg',
  newwhatsappWhite:
    'https://images.myloapp.in/NestJsUploads/1725883269800-whatsapp-icon.svg',
  logout_black:
    'https://images.myloapp.in/NestJsUploads/1680780529592-logout_black_24dp@2x.webp',
  kaftan:
    'https://images.myloapp.in/NestJsUploads/1680850800008-Kaftan-Dresses4-–-6.webp',
  leggings:
    'https://images.myloapp.in/NestJsUploads/1680850800012-Leggings-–-5.webp',
  maternityBra:
    'https://images.myloapp.in/NestJsUploads/1680850800012-Maternity-Bras-–-1.webp',
  maternityDress:
    'https://images.myloapp.in/NestJsUploads/1680850800012-Maternity-Dresses-–-5.webp',
  nighties:
    'https://images.myloapp.in/NestJsUploads/1680850936438-Nighties-–-1.webp',
  midi: 'https://images.myloapp.in/NestJsUploads/1680850936438-Midi-–-5.webp',
  maxi: 'https://images.myloapp.in/NestJsUploads/1680850936437-Maxi-–-5.webp',
  panties:
    'https://images.myloapp.in/NestJsUploads/1680850936436-Maternity-Panties-–-1.webp',
  videoHalfFilledStar:
    'https://images.myloapp.in/NestJsUploads/1689081801648-partially-filled-star.svg',
  videoEmptyStar:
    'https://images.myloapp.in/NestJsUploads/1689081801648-empty-star.svg',
  videoFilledStar:
    'https://images.myloapp.in/NestJsUploads/1689081801645-filled-star.svg',
  bestValue:
    'https://images.myloapp.in/NestJsUploads/1681464752678-Best-Value-Always.webp',
  codAvailable:
    'https://images.myloapp.in/NestJsUploads/1681464752680-COD-Available.webp',
  easyReturn:
    'https://images.myloapp.in/NestJsUploads/1681464752681-Easy-Returns-&-Refunds.webp',
  highQuality:
    'https://images.myloapp.in/NestJsUploads/1681464752681-High-quality-assured.webp',
  double_greater_sign:
    'https://images.myloapp.in/NestJsUploads/1682325988269-double_greater_arro.svg',
  loginIcon:
    'https://images.myloapp.in/NestJsUploads/1727419915858-profile-1.svg',
  down_arrow:
    'https://images.myloapp.in/NestJsUploads/1683006324692-1668773844547-arrowforward_sWR7ZFijx.svg',

  new_linkedin:
    'https://images.myloapp.in/NestJsUploads/1725361599229-linkedin-1.svg',
  new_youtube:
    'https://images.myloapp.in/NestJsUploads/1725361599230-youtube-1.svg',
  new_fb:
    'https://images.myloapp.in/NestJsUploads/1725361599226-facebook-1.svg',
  new_insta:
    'https://images.myloapp.in/NestJsUploads/1725361599230-instagram.svg',
  new_plus:
    'https://images.myloapp.in/NestJsUploads/1683103861613-add_black_24dp-(1).svg',
  new_minus:
    'https://images.myloapp.in/NestJsUploads/1683103973881-remove_black_24dp-(1).webp',
  raise_happiness:
    'https://images.myloapp.in/NestJsUploads/1683719015786-Raise-Happiness.svg',
  backgroundLogin:
    'https://images.myloapp.in/NestJsUploads/1684752999095-Group-329058@3x.webp',
  edit: 'https://images.myloapp.in/NestJsUploads/1684824765188-pen@3x.webp',
  loadingIcon:
    'https://images.myloapp.in/NestJsUploads/1685600167554-Loading_icon.gif',
  loadingGif:
    'https://images.myloapp.in/NestJsUploads/original_gif/1743493350579-Espera-Juan-Gabriel-GIF.gif',
  blackCross:
    'https://images.myloapp.in/NestJsUploads/1685618791520-close_black_48_dp.svg',
  razorpay:
    'https://images.myloapp.in/NestJsUploads/1685364271377-razorpay.svg',
  check_circle_black:
    'https://images.myloapp.in/NestJsUploads/1686119524553-check_circle_black.svg',
  check_circle_outline_black:
    'https://images.myloapp.in/NestJsUploads/1686138052468-check_circle_outline_black_24dp.svg',
  srcle:
    'https://images.myloapp.in/NestJsUploads/1686123803469-check_circle_black_24dp-(2).svg',
  down_arrow_verm:
    'https://images.myloapp.in/NestJsUploads/1686143668896-arrow_back_ios_black_24dp-(1).svg',
  check_circle:
    'https://images.myloapp.in/NestJsUploads/1686123803469-check_circle_black_24dp-(2).svg',

  search:
    'https://images.myloapp.in/NestJsUploads/1685620293921-Group-319017.svg',
  cart_coupon_icon:
    'https://images.myloapp.in/NestJsUploads/1688450148648-coupon-icon.webp',
  cart_error_icon:
    'https://images.myloapp.in/NestJsUploads/1727345583732-cross-icon.svg',
  // coupon_cover:
  //     "https://images.myloapp.in/NestJsUploads/1688541976126-Subtraction-2.webp",
  coupon_spike:
    'https://images.myloapp.in/NestJsUploads/1688550740077-Left-scoupon-spikes.webp',
  arrow_verm_right:
    'https://images.myloapp.in/NestJsUploads/1688621249540-keyboard_arrow_down-24px-(1)@3x.webp',
  tick_consult:
    'https://images.myloapp.in/NestJsUploads/1692018174929-tick_mark.svg',
  doctor_image:
    'https://images.myloapp.in/NestJsUploads/1691735377641-4x5-doctor-image.webp',
  doctor_image_pdp:
    'https://images.myloapp.in/NestJsUploads/1700029542224-doctor.webp',
  arrow_white_light:
    'https://images.myloapp.in/NestJsUploads/1692964380003-Mask-Group-2509.webp',
  arrow_white:
    'https://images.myloapp.in/NestJsUploads/1694424389667-arrow_forward_ios_black_24dp.svg',
  ovulation_banner:
    'https://images.myloapp.in/NestJsUploads/1694429417291-Group-331572@3x.webp',
  ovulation_banner_desktop:
    'https://images.myloapp.in/NestJsUploads/1694521218988-Group-331814@3x.webp',
  headingLogo:
    'https://images.myloapp.in/NestJsUploads/1682404377508-myloLogo.svg',
  locationPayment:
    'https://images.myloapp.in/NestJsUploads/1695029840121-location-icon.svg',
  truck:
    'https://images.myloapp.in/NestJsUploads/1695628046161-Mask-Group-2257.webp',
  delivery:
    'https://images.myloapp.in/NestJsUploads/1695628046163-Mask-Group-2256.webp',
  delivery_crm:
    'https://images.myloapp.in/NestJsUploads/1695206983005-orders-delivered-icon.svg',
  freeDel:
    'https://images.myloapp.in/NestJsUploads/1696312552441-free-delivery.svg',
  easyRet:
    'https://images.myloapp.in/NestJsUploads/1696312552441-easy-returns.svg',
  custSupport:
    'https://images.myloapp.in/NestJsUploads/1696312552441-quick-customer-support.svg',
  genuineProducts:
    'https://images.myloapp.in/NestJsUploads/1696312552437-genuine-products.svg',
  pdpTrust:
    'https://images.myloapp.in/NestJsUploads/1696312552442-baby-mom-image.webp',
  myloBaby:
    'https://images.myloapp.in/NestJsUploads/1696316538483-mylo-baby.svg',
  myloCare:
    'https://images.myloapp.in/NestJsUploads/1732102156445-care_logo.webp',
  arrow_red_new:
    'https://images.myloapp.in/NestJsUploads/1696315944535-SHARP-ARROW@3x.webp',
  baby_name_install_banner:
    'https://images.myloapp.in/NestJsUploads/1701853513961-Baby-Name_1080x1080_V02_01.webp',
  baby_name_install_banner_2:
    'https://images.myloapp.in/NestJsUploads/1701853614846-Baby-Name_1080x1080_V02_02.webp',
  tickSvg: 'https://images.myloapp.in/NestJsUploads/1710748668914-tick.svg',
  bottomCtaImage:
    'https://images.myloapp.in/NestJsUploads/1709196141568-CTA-Strip.webp',
  resultPopupImage:
    'https://images.myloapp.in/NestJsUploads/1709196141570-Group-423134.webp',
  resultBottomImage:
    'https://images.myloapp.in/NestJsUploads/1709196141570-Group-423199.webp',
  checkNew:
    'https://images.myloapp.in/NestJsUploads/1709206658187-tick-mark.webp',
  downloadIcon:
    'https://images.myloapp.in/NestJsUploads/1717756253486-download-icon.webp',
  instaIcon:
    'https://images.myloapp.in/NestJsUploads/1729844487243-instagram-order.svg',
  percentOffIcon:
    'https://images.myloapp.in/NestJsUploads/1753688776115-offer-icon.svg',
};
